import { render } from "./product-thumbnails.vue?vue&type=template&id=b8c0e8e0"
import script from "./product-thumbnails.vue?vue&type=script&lang=js"
export * from "./product-thumbnails.vue?vue&type=script&lang=js"

import "./product-thumbnails.vue?vue&type=style&index=0&id=b8c0e8e0&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__